import {AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable, of, Subscription}                             from 'rxjs';
import {ApElementOxydTypeEnum, MapViewCurrentMenu, MapViewMode}                  from '../../../ap-interface';
import {ApPermissions}                                                           from 'invoker-transport';
import {
  ApDynComponentComponent
}                                                                                from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridPagerConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {GetRoundNumericPipe, GetSoilSampleFieldClassColorPipe}                   from '../../../ap-utils';
import {
  ApDynGridGroupColumnConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridClassColorColumnConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-class-color-column-config';
import {
  SettingsStore
}                                                                                from '../../../stores/base-data/settings.store';
import {
  StatisticStore
}                                                                                from '../../../stores/statistic/statistic.store';
import {
  CampaignYearStore
}                                                                                from '../../../stores/login/campaignyear.store';
import {
  SoilSampleFieldStore
}                                                                                from '../../../stores/evaluation/soilsample.field.store';
import {
  TranslationStore
}                                                                                from '../../../stores/translation/translation.store';
import {MapStore}                                                                from '../../../stores/map/map.store';
import {
  GetPermissionPipe
}                                                                                from '../../../ap-permission/pipes/get-permission.pipe';
import {
  GetRoundNumericService
}                                                                                from '../../../ap-utils/service/get-round-numeric.service';
import {
  ApDynGridStatusColumnConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  JobsStore
}                                                                                from '../../../stores/administration/jobs.store';
import {
  FieldStore
}                                                                                from '../../../stores/farm/field.store';
import {filter, map}                                                             from 'rxjs/operators';
import {ApMapInstance}                                                           from '../../../ap-map';
import {
  LanguageStore
}                                                                                from '../../../stores/translation/language.store';
import {
  ApDateService
}                                                                                from '../../../ap-core/services/ap-date-service';
import {
  GetElementService
}                                                                                from '../../../ap-utils/service/ap-get-element.service';
import {
  ApIcons
}                                                                                from '../../../ap-interface/enums/layout/ap-icons';
import {
  ApUtilService
}                                                                                from '../../../ap-utils/service/ap-util.service';
import {
  LoginStore
}                                                                                from '../../../stores/login/login.store';
import {saveAs}                                                                  from '@progress/kendo-file-saver';
import {
  ApNutrientService
}                                                                                from '../../../ap-utils/service/ap-nutrient.service';
import {APP_CONFIGURATION}                                                       from '../../../ap-core/config';
import {
  ApElementType
}                                                                                from '../../../ap-interface/enums/ap-elements-type.enum';
import {
  ApSoilSampleService
}                                                                                from '../../../nutrient-management/service/ap-soil-sample.service';
import {
  MapViewStore
}                                                                                from '../../../stores/layout/mapview.store';
import {ExportFilenameParts, ISampleFieldGridData}                               from '../../types/sample-fields.types';
import {
  nameOf
}                                                                                from '../../../ap-core/utils/ap-name-of';
import {
  FieldStatisticHistogramService
}                                                                                from '../../../services/data/field-statistic-histogram.service';
import {
  StatisticService
}                                                                                from '../../../services/data/statistic.service';
import {
  SampleTracksInfoSuccess
}                                                                                from '../../../../../projects/invoker-transport/src/lib/actions/evaluation';
import {
  SoilSampleReportComponent
}                                                                                from '../../../ap-reports/components/soil-sample-report/soil-sample-report.component';
import {
  SampleMethodService
}                                                                                from '../../../services/data/sample.method.service';
import {
  IGridStatus
}                                                                                from '../../../ap-interface/interfaces/ap-grid-status.interface';
import {
  LandUseStore
}                                                                                from '../../../stores/base-data/landuse.store';
import {
  LandUseService
}                                                                                from '../../../services/data/landuse.service';
import {
  ApRoleTypeService
}                                                                                from '../../../services/common/ap-role-type.service';
import {
  ApTranslationService
}                                                                                from '../../../ap-utils/service/ap-translation.service';

@Component({
  selector: 'ap-samplefields',
  template: `
    <soil-sample-report #report class="ap-hidden-component"
                        (exportDone)="restoreSelection()"
    ></soil-sample-report>
    <ap-dyncomponent [caption]="'Base_Pages__SampleFields'"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-fields'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [pager]="pager"
                     [groupable]="true"
                     [pdfExportTitle]="'Base_Pages__SampleFields'"
                     [canCreate]="false"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>`
})
export class ApSamplefieldsComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(SoilSampleReportComponent, {static: true}) soilSampleReportComponent: SoilSampleReportComponent;
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public loading$: Observable<boolean> = of(true);
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public items$: Observable<ISampleFieldGridData[]> = of([]);
  public pager: ApDynGridPagerConfigBase = undefined;

  private _applyClicked: EventEmitter<any> = new EventEmitter<any>();
  private _exportFilenameParts: ExportFilenameParts = undefined;
  private _listMassEditing: any[] = [];
  private _subscriptions: Subscription[] = [];

  constructor(private soilSampleFieldStore: SoilSampleFieldStore,
              private campaignYearStore: CampaignYearStore,
              private translationStore: TranslationStore,
              private permissionPipe: GetPermissionPipe,
              private mapStore: MapStore,
              private fieldStore: FieldStore,
              private landUseStore: LandUseStore,
              private roundNumericService: GetRoundNumericService,
              private settingsStore: SettingsStore,
              private soilSampleFieldClassColorPipe: GetSoilSampleFieldClassColorPipe,
              private statisticStore: StatisticStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private jobsStore: JobsStore,
              private languageStore: LanguageStore,
              private dateService: ApDateService,
              private loginStore: LoginStore,
              private mapViewStore: MapViewStore,
              private nutrientService: ApNutrientService,
              private soilSampleService: ApSoilSampleService,
              private elementService: GetElementService,
              private landUseService: LandUseService,
              private statisticService: StatisticService,
              private translationService: ApTranslationService,
              private sampleMethodService: SampleMethodService,
              private fieldStatisticHistogramService: FieldStatisticHistogramService) {
  }

  public ngOnInit(): void {
    this.loading$ = combineLatest([
      this.soilSampleFieldStore.Loading$,
      this.settingsStore.Loading$,
      this.campaignYearStore.Loading$,
      this.fieldStore.Loading$,
      this.languageStore.Loading$,
      this.landUseStore.Loading$
    ]).pipe(
      map(loadingItems => loadingItems.some(x => x))
    );
    this._exportFilenameParts = {DateExpr: '', CustomerExpr: '', Filename: ''};
    this.mapStore.EnableDistributionView();
    this._gridBuilder();
    this._getDataFromStore();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(d => {
      this._selectionChange(d);
    }));
    this._subscriptions.push(this.soilSampleFieldStore.SelectedSoilSampleFields$.subscribe(sf => {
      ApMapInstance.selectSampleField(sf);
    }));
    this._subscriptions.push(this.soilSampleFieldStore.Listen(s => s.exportedShapeFile).subscribe(exportedShapeFile => {
      if (exportedShapeFile && this._exportFilenameParts.Filename?.length > 0) {
        const filename = this._exportFilenameParts.Filename;
        saveAs(new Blob([new Uint8Array(exportedShapeFile)], {type: 'application/zip'}), `${filename}.zip`);
      }
      this.soilSampleFieldStore.resetDownloads();
    }));
    this._subscriptions.push(this.mapViewStore.Listen(d => d.currentMenu).subscribe(mapViewMenu => {
      if (mapViewMenu === MapViewCurrentMenu.STATS) {
        this._selectionChange(this.dynComponent.getSelectedItems() as ISampleFieldGridData[]);
      }
    }));
  }

  public ngOnDestroy(): void {
    this.mapStore.DisableDistributionView();
    this.statisticStore.removeStatisticData();
    this._subscriptions.forEach(d => d?.unsubscribe());
  }

  public restoreSelection(): void {
    const selectedItems = (this.dynComponent.getSelectedItems() as ISampleFieldGridData[]).map(x => x.Id);
    this.soilSampleFieldStore.changeSelectedSampleField(selectedItems);
  }

  private _getDataFromStore(): void {
    this.soilSampleFieldStore.resetDownloads();
    const currentYear = this.campaignYearStore.getSelectedCampaignYear();
    if (!currentYear || currentYear.Year < 2010) {
      return;
    }
    this.items$ = combineLatest([
      this.soilSampleFieldStore.SoilSampleFields$,
      this.fieldStore.Fields$,
      this.settingsStore.FirstSetting$,
      this.landUseStore.LandUse$
    ]).pipe(
      filter(([ssF]) => !!ssF),
      map(([ssF, _, settings, landUses]) => {
        return ssF.map(soilSample => {
          const classP = this._soilClassColor(soilSample.ClassP);
          const classK = this._soilClassColor(soilSample.ClassK);
          const classMG = this._soilClassColor(soilSample.ClassMg);
          const classPH = this._soilClassColor(soilSample.ClassPh);
          const pIsGreaterE = soilSample.ClassP === 'E';
          const kIsGreaterE = soilSample.ClassK === 'E';
          const mgIsGreaterE = soilSample.ClassMg === 'E';
          const phIsGreaterE = soilSample.ClassPh === 'E';
          const pValue = this.nutrientService.convertElementOxid(soilSample.P, ApElementOxydTypeEnum.P, soilSample.MethodP);
          const kValue = this.nutrientService.convertElementOxid(soilSample.K, ApElementOxydTypeEnum.K, soilSample.MethodK);
          const mgValue = this.nutrientService.convertElementOxid(soilSample.Mg, ApElementOxydTypeEnum.Mg, soilSample.MethodPh);
          const phValue = soilSample.Ph;
          const pValueRounded = this.roundNumericService.roundAsNumber(pValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const kValueRounded = this.roundNumericService.roundAsNumber(kValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const mgValueRounded = this.roundNumericService.roundAsNumber(mgValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const phValueRounded = this.roundNumericService.roundAsNumber(phValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const item: ISampleFieldGridData = {
            Id: soilSample.Id,
            SourceItem: soilSample,
            Status: this.landUseService.getLandUseAsStatus(soilSample?.LandUse, landUses),
            FieldNumber: soilSample.FieldNumber,
            FieldPart: soilSample.FieldPart,
            FieldName: soilSample.FieldName,
            SoilGroups: soilSample.SoilGroups,
            NrSNr: this.soilSampleService.getFieldNumberAndSubNumber(soilSample),
            Area: this.roundNumericService.roundAsNumber(soilSample.AreaHa, settings.DigitsAfterDecimalPoint),
            SampleDate: soilSample.SampleDate ? this.dateService.getDateMidnight(soilSample.SampleDate) : null,
            SampleTracksCount: soilSample.SampleTracksCount,
            ClassP: classP,
            ClassK: classK,
            ClassMg: classMG,
            ClassPh: classPH,
            PValue: pValueRounded,
            KValue: kValueRounded,
            MgValue: mgValueRounded,
            PhValue: phValueRounded,
            PIsGreaterE: pIsGreaterE,
            KIsGreaterE: kIsGreaterE,
            MgIsGreaterE: mgIsGreaterE,
            PhIsGreaterE: phIsGreaterE,
            PValueTooltip: this.nutrientService.formatClassificationTooltip(soilSample.P, pIsGreaterE, soilSample.MethodP),
            KValueTooltip: this.nutrientService.formatClassificationTooltip(soilSample.K, kIsGreaterE, soilSample.MethodK),
            MgValueTooltip: this.nutrientService.formatClassificationTooltip(soilSample.Mg, mgIsGreaterE, soilSample.MethodMg),
            PhValueTooltip: this.nutrientService.formatClassificationTooltip(soilSample.Ph, phIsGreaterE, soilSample.MethodPh),
            PContentTooltip: this.sampleMethodService.getUnitWithMethod(soilSample.MethodP),
            KContentTooltip: this.sampleMethodService.getUnitWithMethod(soilSample.MethodK),
            MgContentTooltip: this.sampleMethodService.getUnitWithMethod(soilSample.MethodMg),
            PhContentTooltip: this.sampleMethodService.getUnitWithMethod(soilSample.MethodPh)
          };
          return item;
        });
      })
    );
  }

  private _gridBuilder(): void {
    this.columns$ = combineLatest([
      this.settingsStore.FirstSetting$,
      this.languageStore.SelectedLanguage$
    ]).pipe(
      filter(([settings, selectedLanguage]) => !!settings && !!selectedLanguage),
      map(([settings, selectedLanguage]) => {
        const columns: ApDynGridColumnConfigBase[] = [
          new ApDynGridStatusColumnConfig({
            field: `${nameOf<ISampleFieldGridData>('Status')}.${nameOf<IGridStatus>('state')}`,
            class: `${nameOf<ISampleFieldGridData>('Status')}.${nameOf<IGridStatus>('class')}`,
            description: `${nameOf<ISampleFieldGridData>('Status')}.${nameOf<IGridStatus>('description')}`,
            title: 'LandUse',
            groupTitle: 'LandUse',
            showHeaderTitle: false,
            pending: this.jobsStore.BlockedSoilSampleFieldIdsBu$,
            pendingTooltip: this.jobsStore.BlockedSoilSampleFieldIdsBuTooltip$,
            groupIndex: 0,
            groupDesc: false
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('FieldNumber'),
            title: 'Global__NumberAbbr',
            filterable: true,
            hide: true,
            width: 60,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('FieldPart'),
            title: 'Global__FieldPartShort',
            filterable: true,
            hide: true,
            width: 60,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('NrSNr'),
            title: 'Global__NumberAbbr',
            width: 75,
            filterable: true,
            headerFilterable: true,
            hide: new ApDynGridColumnHideConfig({
              mapHide: false,
              selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
            })
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('FieldName'),
            title: 'Global__Name',
            filterable: true,
            width: 180,
            headerFilterable: true,
            sortIndex: 0
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('Area'),
            title: 'Base__ManagementStyle_ha',
            filterable: true,
            width: 60,
            headerFilterable: true,
            cssClass: 'right', filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [settings.DigitsAfterDecimalPoint]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('SampleDate'),
            title: 'Global__SampleDate',
            filterType: FilterType.DATE,
            format: selectedLanguage.DateFormat,
            filterable: true,
            width: 80,
            hide: true,
            headerFilterable: true
          })
        ];
        if (ApRoleTypeService.hasAgriconRole(this.loginStore.User)) {
          columns.push(new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('SampleTracksCount'),
            title: 'SampleTracksCount',
            filterable: true,
            width: 60,
            hide: true,
            headerFilterable: true
          }));
        }
        return columns.concat([
          new ApDynGridPropertyColumnConfig({
            field: nameOf<ISampleFieldGridData>('SoilGroups'),
            title: 'Nutrients__Soilgroups',
            filterable: true,
            width: 80,
            hide: true,
            headerFilterable: true
          }),
          new ApDynGridGroupColumnConfig({
            headerStyle: {
              'text-align': 'center'
            },
            style: {border: '1px solid #2c3237'},
            title: 'Global__Avg_Class',
            groupColumns: [
              new ApDynGridClassColorColumnConfig({
                field: nameOf<ISampleFieldGridData>('ClassP'),
                title: this.elementService.GetElementStringByString(ApElementType.P),
                key: 'SourceItem.ClassP',
                width: 45,
                tooltip: 'PValueTooltip',
                cssClass: 'center'
              }),
              new ApDynGridClassColorColumnConfig({
                field: nameOf<ISampleFieldGridData>('ClassK'),
                title: this.elementService.GetElementStringByString(ApElementType.K),
                key: 'SourceItem.ClassK',
                width: 45,
                tooltip: 'KValueTooltip',
                cssClass: 'center'
              }),
              new ApDynGridClassColorColumnConfig({
                field: nameOf<ISampleFieldGridData>('ClassMg'),
                title: this.elementService.GetElementStringByString(ApElementType.Mg),
                key: 'SourceItem.ClassMg',
                width: 45,
                tooltip: 'MgValueTooltip',
                cssClass: 'center'
              }),
              new ApDynGridClassColorColumnConfig({
                field: nameOf<ISampleFieldGridData>('ClassPh'),
                title: 'Global__Nutrient_pH_Short',
                key: 'SourceItem.ClassPh',
                width: 45,
                tooltip: 'PhValueTooltip',
                cssClass: 'center'
              }),
            ]
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Global__Content',
            headerStyle: {
              'text-align': 'center'
            },
            style: {border: '1px solid #2c3237'},
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ISampleFieldGridData>('PValue'),
                title: this.elementService.GetElementStringByString(ApElementType.P),
                tooltip: (dataItem: ISampleFieldGridData) => dataItem.PContentTooltip,
                width: 45,
                hide: true,
                formatCallback: (dataItem, value) => `${(dataItem?.PIsGreaterE ? '> ' : '')}${value}`,
                cssClass: 'right', filterType: FilterType.NUMBER,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [APP_CONFIGURATION.SpecialDecimalPlaces.Distributions]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ISampleFieldGridData>('KValue'),
                title: this.elementService.GetElementStringByString(ApElementType.K),
                tooltip: (dataItem: ISampleFieldGridData) => dataItem.KContentTooltip,
                width: 45,
                hide: true,
                formatCallback: (dataItem, value) => `${(dataItem?.KIsGreaterE ? '> ' : '')}${value}`,
                cssClass: 'right', filterType: FilterType.NUMBER,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [APP_CONFIGURATION.SpecialDecimalPlaces.Distributions]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ISampleFieldGridData>('MgValue'),
                title: this.elementService.GetElementStringByString(ApElementType.Mg),
                tooltip: (dataItem: ISampleFieldGridData) => dataItem.MgContentTooltip,
                width: 35,
                hide: true,
                formatCallback: (dataItem, value) => `${(dataItem?.MgIsGreaterE ? '> ' : '')}${value}`,
                cssClass: 'right', filterType: FilterType.NUMBER,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [APP_CONFIGURATION.SpecialDecimalPlaces.Distributions]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ISampleFieldGridData>('PhValue'),
                title: 'Elem_Ph_short',
                tooltip: (dataItem: ISampleFieldGridData) => dataItem.PhContentTooltip,
                width: 45,
                hide: true,
                formatCallback: (dataItem, value) => `${(dataItem?.PhIsGreaterE ? '> ' : '')}${value}`,
                cssClass: 'right', filterType: FilterType.NUMBER,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [APP_CONFIGURATION.SpecialDecimalPlaces.Distributions]
                }]
              })
            ]
          })
        ]);
      }));
    this._subscriptions.push(this.permissionPipe.transform(ApPermissions.SHOW_SOIL_SAMPLE_FIELDS).subscribe(permissions => {
        this.pager = new ApDynGridPagerConfig(
          {
            listMassEditing: this._listMassEditing,
            apply: this._applyClicked,
            hasPermission: permissions,
            iconButtons: [
              {
                icon: ApIcons.PDF,
                callback: ApUtilService.createEventEmitter(this._onExportPdf.bind(this), this._subscriptions),
                tooltip: 'Global__Save_PDF'
              },
              {
                icon: ApIcons.Print,
                callback: ApUtilService.createEventEmitter(this._onExportPdfReport.bind(this), this._subscriptions),
                tooltip: 'Report__GenerateSample'
              },
              {
                icon: ApIcons.XLS,
                callback: ApUtilService.createEventEmitter(this._onExportXls.bind(this), this._subscriptions),
                tooltip: 'Global__Save_EXCEL'
              },
              {
                icon: ApIcons.Shape,
                callback: ApUtilService.createEventEmitter(this._onExportShape.bind(this), this._subscriptions),
                tooltip: 'Nutrients_Ips_Pages__ShpExport'
              }
            ]
          });
      })
    );
  }

  private _onExportPdf(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this._generateExportFilename('Base_Pages__SampleFields');
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private _onExportPdfReport(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this._generateExportFilename('Base_Pages__SampleFields');
    const selectedItems = this.dynComponent.getSelectedItems()?.map(x => x as ISampleFieldGridData);
    this.soilSampleFieldStore.sampleTracksInfo(selectedItems.map(x => x.Id)).watchStream({
      action: SampleTracksInfoSuccess,
      todo: payload => {
        if (!payload.Error) {
          this.soilSampleFieldStore.SetLoadFinishState();
          this.soilSampleReportComponent.itemsFieldLevel = selectedItems;
          this.soilSampleReportComponent.itemsSampleTrackByField = payload.Data;
          this.soilSampleFieldStore.changeSelectedSampleField([]);
          this.soilSampleReportComponent.createAndSaveReport();
        } else {
          this.soilSampleFieldStore.SetLoadFailState();
        }
      },
    });
  }

  private _onExportXls(): void {
    this._generateExportFilename('SamplePoints');
    const soilSampleIds = this.dynComponent.getSelectedItems()?.length > 0 ?
      this.dynComponent.getSelectedItems()?.map(_ => _?.Id) :
      this.dynComponent.items?.map(_ => _?.Id);
    if (!soilSampleIds || soilSampleIds.length <= 0) {
      return;
    }
    this.soilSampleFieldStore.samplePointsExcelExport(soilSampleIds, this._exportFilenameParts.Filename);
  }

  private _onExportShape(): void {
    this._generateExportFilename('SampleTracks');
    const soilSampleIds = this.dynComponent.getSelectedItems()?.length > 0
      ? this.dynComponent.getSelectedItems()?.map(_ => _?.Id)
      : this.dynComponent.items?.map(_ => _?.Id);

    if (!soilSampleIds || soilSampleIds.length <= 0) {
      return;
    }
    this.soilSampleFieldStore.sampleTracksShapeExport(soilSampleIds,
      this._exportFilenameParts.DateExpr,
      this._exportFilenameParts.CustomerExpr);
  }

  private _generateExportFilename(formatExpr: string): string {
    this._exportFilenameParts.CustomerExpr = this.loginStore.SelectedFarm?.CustomerNumber;
    this._exportFilenameParts.DateExpr = this.dateService.toFarmDate(new Date()).format('YYMMDD');
    this._exportFilenameParts.Filename = `${this._exportFilenameParts.DateExpr}_${this.translationStore.FindTranslationForSelectedLanguage(formatExpr)}_${this._exportFilenameParts.CustomerExpr}`;
    return this._exportFilenameParts.Filename;
  }

  private _soilClassColor(value: string): any {
    return this.soilSampleFieldClassColorPipe.transform(value, [false]);
  }

  private _selectionChange(items: ISampleFieldGridData[]): void {
    let itemsToSelect: ISampleFieldGridData[] = items;
    if (itemsToSelect && itemsToSelect.length > 0) {
      this.soilSampleFieldStore.changeSelectedSampleField(itemsToSelect.map(x => x.Id));
    } else {
      itemsToSelect = this.dynComponent.items as ISampleFieldGridData[];
      this.soilSampleFieldStore.changeSelectedSampleField([]);
      this.fieldStore.zoomFarmFields();
    }
    // calculate statistic only if user is on statistic tab
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS) {
      return;
    }
    setTimeout(() => {
      this.statisticStore.removeStatisticData();
      const statisticData = itemsToSelect.map(item => {
        return {
          Status: item.Status.state,
          FieldId: undefined,
          FieldName: item.FieldName,
          AreaHa: item.Area ?? 0,
          Histograms: item.SourceItem.Histograms
        };
      });
      const title = this._getTitleForStatistic(itemsToSelect);
      this.fieldStatisticHistogramService.generateHistogramStatistic(title, statisticData);
    }, 0);
  }

  private _getTitleForStatistic(selectedItems: ISampleFieldGridData[]): string {
    const totalItems = this.dynComponent.items as ISampleFieldGridData[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    let title = this.statisticService.generateFieldsAreaTitle(dataForTitles);
    if (ApRoleTypeService.hasAgriconRole(this.loginStore.User)) {
      const sampleTracksCount = selectedItems.reduce((prev, curr) => prev + (curr.SampleTracksCount ?? 0), 0);
      title += `\n${sampleTracksCount} ${this.translationService.translate('Nutrients_Pages__Samples')}`;
    }
    return title;
  }
}
